import React from 'react';

export function TitleSection({ userNames, speed }) {
    const tileStyle = {
        animation: `swipe ${speed}ms linear infinite`,
    };

    return (
        <div className='net-titles' style={tileStyle}>
            {userNames && userNames.map(({ userName,logo  }, index) => (
                <div key={index} className='net-title'>
                    <img src={logo} alt={userName} className="company-logo" />
                    {/* <img src={src} alt={name} /> */}
                </div>
            ))}
        </div>
    );
}

export default function Notificationscroll({ userNames, speed }) {
    return (
        <div className='banner-wrapper'>
            <div className='wrapper'>
                <TitleSection userNames={userNames} speed={speed} />
                <TitleSection userNames={userNames} speed={speed} />
                <TitleSection userNames={userNames} speed={speed} />
                
            </div>
        </div>
    );
}